var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3764 9.47687C13.0464 7.13367 12.8302 3.85958 10.728 1.75736C8.38485 -0.585787 4.58586 -0.585786 2.24271 1.75736C-0.100435 4.1005 -0.100435 7.89949 2.24271 10.2426C4.34494 12.3449 7.61902 12.561 9.96222 10.8911L15.6777 16.6066L17.092 15.1924L11.3764 9.47687ZM9.31378 3.17157C10.8759 4.73367 10.8759 7.26633 9.31378 8.82843C7.75168 10.3905 5.21902 10.3905 3.65692 8.82843C2.09483 7.26633 2.09483 4.73367 3.65692 3.17157C5.21902 1.60948 7.75168 1.60948 9.31378 3.17157Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.72244b88.svg";
export { ForwardRef as ReactComponent };